import React, { Component, Fragment } from "react";
import Pagination from "assets/scripts/components/presentational/Pagination/Pagination";
import { FormattedMessage } from "react-intl";
import AccountCard from "./AccountCard/AccountCard";
import styles from "./AccountList.module.less";
export default class AccountList extends Component {
    render() {
        const { props } = this;
        return (<Pagination items={props.accts} itemsPerPage={3}>
				{({ page, renderPager, pageCount, itemIndex }) => (<div data-test="AccountList">
						<div className="vr vr_x4">
							<h2 className="hdg">
								<FormattedMessage {...props.header}/>
								{pageCount > 1 && (<span className={styles.pageSummary}>
										<FormattedMessage id="dashboard.accountList.pageSummary" defaultMessage="(showing {start, number} - {end, number} of {total, number})" values={{
            start: itemIndex + 1,
            end: itemIndex + page.length,
            total: props.accts.length
        }}/>
									</span>)}
							</h2>
						</div>
						<div className="vr vr_x7">
							<Fragment>
								{page.map(routeGroup => (<AccountCard key={routeGroup.primary.id} routeGroup={routeGroup} disclaimerIdMap={props.disclaimerIdMap} showDisclaimerLinks={props.showDisclaimerLinks} openModal={props.openModal} setAccountToEdit={props.setAccountToEdit}/>))}
								{renderPager("Accounts")}
							</Fragment>
						</div>
					</div>)}
			</Pagination>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountList.tsx